import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
import { PosNegEnum } from "@rmh/defs";
import type { ChangeEvent } from "react";
import { useState } from "react";

interface PosNegSubInputProps {
  defaultValue: PosNegEnum | null;
  onInputChange?: (...values: unknown[]) => void;
  disabled?: boolean;
}

function PosNegSubInput({
  defaultValue,
  onInputChange,
  disabled
}: PosNegSubInputProps){
  const [value, setValue] = useState<PosNegEnum | null>(defaultValue);
  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    let newValue = PosNegEnum.Negative;
    if ((PosNegEnum.Positive as string) === e.target.value)
      newValue = PosNegEnum.Positive;
    setValue(newValue);
    if (onInputChange) {
      onInputChange(newValue);
    }
  };

  return (
    <RadioGroup>
      <FormControlLabel
        control={
          <Radio checked={value === PosNegEnum.Positive} onChange={onChange} />
        }
        disabled={disabled ? value !== PosNegEnum.Positive : false}
        label="Pos (+)"
        value={PosNegEnum.Positive}
      />
      <FormControlLabel
        control={
          <Radio checked={value === PosNegEnum.Negative} onChange={onChange} />
        }
        disabled={disabled ? value !== PosNegEnum.Negative : false}
        label="Neg (-)"
        value={PosNegEnum.Negative}
      />
    </RadioGroup>
  );
}

export default PosNegSubInput;
